/** Map React Router pathname to API page slug (empty path → home). */
export function pathnameToPageSlug(pathname: string): string {
  const trimmed = pathname.replace(/^\/+|\/+$/g, "");
  return trimmed || "home";
}
